import React, { Component } from "react";
import img_icon_delete from '../img/icons/delete.png';
import img_icon_edit from '../img/icons/edit.png';
import img_plat1 from '../img/food/plat1.jpg';
import img_plat2 from '../img/food/plat2.jpg';
import img_plat3 from '../img/food/plat3.jpg';
import { connect } from "react-redux";
import { changeFoods, changeAllergens, changeImages, changeCount, changePopupS, changePopupC } from "../actions/index";
import { delete_food, delete_allergen, delete_image, post_image, post_allergen, put_food } from '../api/UserFunctions';

function mapDispatchToProps(dispatch) {
    return {
      changeFoods:foods => dispatch(changeFoods(foods)),
      changeAllergens:allergens => dispatch(changeAllergens(allergens)),
      changeImages:images => dispatch(changeImages(images)),
      changePopupS:style_popup => dispatch(changePopupS(style_popup)),
      changePopupC:text_popup => dispatch(changePopupC(text_popup)),
      changeCount:count => dispatch(changeCount(count))
    };
}

const mapStateToProps = state => {
	return { foods: state.foods, allergens: state.allergens, images: state.images, count: state.count, categories: state.categories };
  }; 


class FoodWrapperAdmin extends Component {

    constructor(){
        super();
        this.state = {
            selectedFile: null,
            food_name      : "",
			description    : "",
			price          : 0,
			allergen1      : "Aucun",
			allergen2      : "Aucun",
			allergen3      : "Aucun",
			allergen4      : "Aucun",
			allergen5      : "Aucun",
			allergen6      : "Aucun",
			allergen7      : "Aucun",
			allergen8      : "Aucun",
            allergen10      : "Aucun",
			allergen20     : "Aucun",
			allergen30      : "Aucun",
			allergen40      : "Aucun",
			allergen50      : "Aucun",
			allergen60      : "Aucun",
			allergen70      : "Aucun",
			allergen80      : "Aucun",
			stock          : "oui",
			dayfood        : "non",
			category_choice: "",
            display_name: "",
            selectSort:1
        };
        this.handleDelete = this.handleDelete.bind(this);
        
        this.handleModify = this.handleModify.bind(this);
        this.onChange = this.onChange.bind(this);
        
    }


    onChange(e) {
        this.setState({ [e.target.name]: e.target.value })
      }

      


    handleModify(event) {
        event.preventDefault();
        
        console.log("okk");
        this.props.popupParentCallback({display:"inline-flex"}, "Le nom ne peut pas être vide !", "error");
        
        if(this.state.food_name.localeCompare("") !== 0){
        
        this.props.popupParentCallback({display:"inline-flex"}, "Le plat à été modifié avec succès", "success");
        var category_id;
		var stockString;
		var dayfoodString;

		if(this.state.stock.localeCompare("non")==0){
			stockString="false";
		}
		else{
			stockString="true";
		}

		if(this.state.dayfood.localeCompare("non")==0){
			dayfoodString="false";
		}
		else{
			dayfoodString="true";
		}

		this.props.categories.forEach((category,index) => {
					
			if(this.state.category_choice.localeCompare("")==0 && index == 0){
				category_id = category["id"];
			}
			else if(category["name"] == this.state.category_choice){
				category_id = category["id"];
			}
		  
		  });
            var _food = {
                id:this.props.id,
                name: this.state.food_name,
                id_category : this.props.category_id,
                description : this.state.description,
                is_active : stockString,
                is_emphased : dayfoodString,
                price: this.state.price,
                sortList:this.state.selectSort
            }
            var active;
            var emphased;
            put_food(_food).then(res => {
                      console.log("log "+_food.name+" "+JSON.stringify(res)+ " "+this.props.id);
                if(typeof(this.props.foods[0]) !== "undefined"){
                    var total = [];
                    
                        this.props.foods.forEach((food,index) => {
                            if(food.is_active){
                                active = "true";
                            }
                            else{
                                active = "false"
                            }
                            if(food.is_emphased){
                                emphased = "true";
                            }
                            else{
                                emphased = "false"
                            }
                            if(parseInt(food.id_category) === parseInt(this.props.category_id)){
                                if(parseInt(this.state.selectSort) !== parseInt(this.props.selectSort) ){
                                    if(parseInt(food.sortList) === parseInt(this.state.selectSort) ){
                                      var new2 = {
                                          id:food.id,
                                          name: food.name,
                                          id_category : food.id_category,
                                          description : food.description,
                                          is_active : active,
                                          is_emphased : emphased,
                                          price: food.price,
                                          sortList:this.props.selectSort
                                      }	
                                        total.push(new2);
                                        put_food(new2).then(res => {});
                                    }
                                    else if(food["id"] !== this.props.id){
                                      total.push(food);
                                  }
                                  else{
                                    total.push(_food);
                                  }
                                }
                                else{
                                  if(food["id"] !== this.props.id){
                                      total.push(food);
                                  }
                                  else{
                                    total.push(_food);
                                  }
                                }      
                            }
                            else{
                                total.push(food);
                            }
                                  
                          
                        
                        });
                    
                    
                        
                    total.sort((a, b) => a.sortList - b.sortList);
                    console.log("modify "+JSON.stringify(total));
                    this.props.changeFoods(total);
                    }
              });
              if(this.state.allergen10.localeCompare(this.state.allergen1)!==0){
                const allergen1 = {
                    name: this.state.allergen1,
                    id_food: this.props.id					
                }
                var test = true;
                this.props.allergens.forEach((allergen,index) => {
                    if(allergen.id_food === this.props.id){
                        if(this.state.allergen1.localeCompare(allergen.name)===0){
                            test = false;
                        }
                        
                        if(this.state.allergen10.localeCompare(allergen.name)===0 && this.state.allergen10.localeCompare(this.state.allergen1)!==0){
                            console.log("last "+this.state.allergen10+" "+allergen.name+" "+this.state.allergen1)
                            delete_allergen(allergen["id"]).then(res => {
                            });
                        }
                    }
                });
                if(test){
                    post_allergen(allergen1).then(all => {
                        if(typeof(this.props.allergens[0]) !== "undefined"){
                            var total = this.props.allergens;
                            
                            total.push(all);
                            this.props.changeAllergens(total);
                        }	
                    });
                }

                
            }

            if(this.state.allergen20.localeCompare(this.state.allergen2)!==0){
                const allergen2 = {
                    name: this.state.allergen2,
                    id_food: this.props.id					
                }
                var test = true;
                this.props.allergens.forEach((allergen,index) => {
                    if(allergen.id_food === this.props.id){
                        if(this.state.allergen2.localeCompare(allergen.name)===0){
                            test = false;
                        }
                        if(this.state.allergen20.localeCompare(allergen.name)===0 && this.state.allergen20.localeCompare(this.state.allergen2)!==0){
                            delete_allergen(allergen["id"]).then(res => {
                            });
                        }
                    }
                });
                if(test){
                    post_allergen(allergen2).then(all => {
                        if(typeof(this.props.allergens[0]) !== "undefined"){
                            var total = this.props.allergens;
                            
                            total.push(all);
                            this.props.changeAllergens(total);
                        }	
                    });
                }
            }

            if(this.state.allergen30.localeCompare(this.state.allergen3)!==0){
                const allergen3 = {
                    name: this.state.allergen3,
                    id_food: this.props.id					
                }
                var test = true;
                this.props.allergens.forEach((allergen,index) => {
                    if(allergen.id_food === this.props.id){
                        if(this.state.allergen3.localeCompare(allergen.name)===0){
                            test = false;
                        }
                        if(this.state.allergen30.localeCompare(allergen.name)===0 && this.state.allergen30.localeCompare(this.state.allergen3)!==0){
                            delete_allergen(allergen["id"]).then(res => {
                            });
                        }
                    }
                });
                if(test){
                    post_allergen(allergen3).then(all => {
                        if(typeof(this.props.allergens[0]) !== "undefined"){
                            var total = this.props.allergens;
                            
                            total.push(all);
                            this.props.changeAllergens(total);
                        }	
                    });
                }
            }

            if(this.state.allergen40.localeCompare(this.state.allergen4)!==0){
                const allergen4 = {
                    name: this.state.allergen4,
                    id_food: this.props.id					
                }
                var test = true;
                this.props.allergens.forEach((allergen,index) => {
                    if(allergen.id_food === this.props.id){
                        if(this.state.allergen4.localeCompare(allergen.name)===0){
                            test = false;
                        }
                        if(this.state.allergen40.localeCompare(allergen.name)===0 && this.state.allergen40.localeCompare(this.state.allergen4)!==0){
                            delete_allergen(allergen["id"]).then(res => {
                            });
                        }
                    }
                });
                if(test){
                    post_allergen(allergen4).then(all => {
                        if(typeof(this.props.allergens[0]) !== "undefined"){
                            var total = this.props.allergens;
                            
                            total.push(all);
                            this.props.changeAllergens(total);
                        }	
                    });
                }
            }

            if(this.state.allergen50.localeCompare(this.state.allergen5)!==0){
                const allergen5 = {
                    name: this.state.allergen5,
                    id_food: this.props.id					
                }
                var test = true;
                this.props.allergens.forEach((allergen,index) => {
                    if(allergen.id_food === this.props.id){
                        if(this.state.allergen5.localeCompare(allergen.name)===0){
                            test = false;
                        }
                        if(this.state.allergen50.localeCompare(allergen.name)===0 && this.state.allergen50.localeCompare(this.state.allergen5)!==0){
                            delete_allergen(allergen["id"]).then(res => {
                            });
                        }
                    }
                });
                if(test){
                    post_allergen(allergen5).then(all => {
                        if(typeof(this.props.allergens[0]) !== "undefined"){
                            var total = this.props.allergens;
                            
                            total.push(all);
                            this.props.changeAllergens(total);
                        }	
                    });
                }
            }

            if(this.state.allergen60.localeCompare(this.state.allergen6)!==0){
                const allergen6 = {
                    name: this.state.allergen6,
                    id_food: this.props.id					
                }
                var test = true;
                this.props.allergens.forEach((allergen,index) => {
                    if(allergen.id_food === this.props.id){
                        if(this.state.allergen6.localeCompare(allergen.name)===0){
                            test = false;
                        }
                        if(this.state.allergen60.localeCompare(allergen.name)===0 && this.state.allergen60.localeCompare(this.state.allergen6)!==0){
                            delete_allergen(allergen["id"]).then(res => {
                            });
                        }
                    }
                });
                if(test){
                    post_allergen(allergen6).then(all => {
                        if(typeof(this.props.allergens[0]) !== "undefined"){
                            var total = this.props.allergens;
                            
                            total.push(all);
                            this.props.changeAllergens(total);
                        }	
                    });
                }
            }

            if(this.state.allergen70.localeCompare(this.state.allergen7)!==0){
                const allergen7 = {
                    name: this.state.allergen7,
                    id_food: this.props.id					
                }
                var test = true;
                this.props.allergens.forEach((allergen,index) => {
                    if(allergen.id_food === this.props.id){
                        if(this.state.allergen7.localeCompare(allergen.name)===0){
                            test = false;
                        }
                        if(this.state.allergen70.localeCompare(allergen.name)===0 && this.state.allergen70.localeCompare(this.state.allergen7)!==0){
                            delete_allergen(allergen["id"]).then(res => {
                            });
                        }
                    }
                });
                if(test){
                    post_allergen(allergen7).then(all => {
                        if(typeof(this.props.allergens[0]) !== "undefined"){
                            var total = this.props.allergens;
                            
                            total.push(all);
                            this.props.changeAllergens(total);
                        }	
                    });
                }
            }

            if(this.state.allergen80.localeCompare(this.state.allergen8)!==0){
                const allergen8 = {
                    name: this.state.allergen8,
                    id_food: this.props.id					
                }
                var test = true;
                this.props.allergens.forEach((allergen,index) => {
                    if(allergen.id_food === this.props.id){
                        if(this.state.allergen8.localeCompare(allergen.name)===0){
                            test = false;
                        }
                        if(this.state.allergen80.localeCompare(allergen.name)===0 && this.state.allergen80.localeCompare(this.state.allergen8)!==0){
                            delete_allergen(allergen["id"]).then(res => {
                            });
                        }
                    }
                });
                if(test){
                    post_allergen(allergen8).then(all => {
                        if(typeof(this.props.allergens[0]) !== "undefined"){
                            var total = this.props.allergens;
                            
                            total.push(all);
                            this.props.changeAllergens(total);
                        }	
                    });
                }

                
            }


            if(this.state.selectedFile !== null){
                const file = {
                    id_food: this.props.id,
                    selectedFile:this.state.selectedFile					
                }
                post_image(file).then(img => {
                    if(typeof(this.props.images[0]) !== "undefined"){
                        var total = this.props.images;
						total.push(img);
						this.props.changeImages(total);
						var count = 0;
							this.props.foods.forEach((food,index) => {
												
								if(this.props.category_id === food.id_category){
									count++;
								}
							
							});
					
							if(count>=4){
								count=4;
							}



							var big = [];
							var key = category_id;
							var puzzle  = {}
							puzzle[key] = count;
							this.props.count.forEach((counter,index) => {	
								
								var keys = Object.keys(counter);
								console.log("actualise "+category_id+" "+parseInt(keys[0]));		
								if( category_id === parseInt(keys[0])){
									console.log("actualise");
									big.push(puzzle);
								}
								else{
									big.push(counter);
								}
                        
                
                        
                    
                });
                this.props.changeCount(big);
            }
            
        });

                this.props.images.forEach((image,index) => {
                                            
                    if(image.id_food === this.props.id){
                        delete_image(image["id"]).then(res => {
                            var big = [];
                            this.props.count.forEach((counter,index) => {			
                                var keys = Object.keys(counter);		
                                if(this.props.id === parseInt(keys[0])){
                                    //big = [];
                                }
                                else{
                                    big.push(counter);
                                }
                            
                            });
                                this.props.changeCount(big);
                                var big = [];
                                this.props.images.forEach((image,index) => {
                                    if(this.props.id === image.id_food){
                                        //big = [];
                                    }
                                    else{
                                        big.push(image);
                                    }
                                
                                });
                                this.props.changeImages(big);
                        });
                    }
                });
                
                        
                        
                        
            }
            
            
              
        }
        
       
    }



    componentDidMount(){
        this.setState({ food_name: this.props.food_name, description: this.props.description, price: this.props.price, selectSort: this.props.selectSort });
        if(this.props.is_active){
            this.setState({stock:"oui"});
        }
        else{
            this.setState({stock:"non"});
        }

        if(this.props.is_emphased){
            this.setState({dayfood:"oui"});
        }
        else{
            this.setState({dayfood:"non"});
        }
        var count = 0;
        var all_all = this.props.allergens;
        all_all.sort((b, a) => a.id - b.id);
        all_all.forEach((allergen,index) => {
							
            if(count == 0 && allergen.id_food == this.props.id){
                console.log(" into food : "+JSON.stringify(allergen)+" "+allergen.id_food+" "+this.props.id)
                this.setState({allergen1:allergen.name});
                this.setState({allergen10:allergen.name});
                count++;
            }
            else if(count == 1 && allergen.id_food == this.props.id){
                this.setState({allergen2:allergen.name});
                this.setState({allergen20:allergen.name});
                count++;
            }
            else if(count == 2 && allergen.id_food == this.props.id){
                this.setState({allergen3:allergen.name});
                this.setState({allergen30:allergen.name});
                count++;
            }
            else if(count == 3 && allergen.id_food == this.props.id){
                this.setState({allergen4:allergen.name});
                this.setState({allergen40:allergen.name});
                count++;
            }
            else if(count == 4 && allergen.id_food == this.props.id){
                this.setState({allergen5:allergen.name});
                this.setState({allergen50:allergen.name});
                count++;
            }
            else if(count == 5 && allergen.id_food == this.props.id){
                this.setState({allergen6:allergen.name});
                this.setState({allergen60:allergen.name});
                count++;
            }
            else if(count == 6 && allergen.id_food == this.props.id){
                this.setState({allergen7:allergen.name});
                this.setState({allergen70:allergen.name});
                count++;
            }
            else if(count == 7 && allergen.id_food == this.props.id){
                this.setState({allergen8:allergen.name});
                this.setState({allergen80:allergen.name});
                count++;
            }
          
          });

          this.props.images.forEach((image,index) => {
							
            if(image.id_food == this.props.id){
                this.setState({display_name:image.name});
            }
          
          });

          this.props.foods.forEach((food,index) => {
            if(food.name.localeCompare(this.props.name)===0){
                this.setState({selectSort:food.sortList});
            }
        });
    }

    handleDelete(event) {
        event.preventDefault();
        if(typeof(this.props.foods[0]) !== "undefined"){
            var total2 = []
            var counting2 = 0;
            var patch2 = false;
            var active;
            var emphased;
            this.props.foods.forEach((food,index) => {
                
                    if(food["id"] !== this.props.id && food["id_category"] === this.props.category_id){
                        counting2++;
                        if(food.is_active){
                            active = "true";
                        }
                        else{
                            active = "false"
                        }
                        if(food.is_emphased){
                            emphased = "true";
                        }
                        else{
                            emphased = "false"
                        }
                        var new1={
                            id:food.id,
                            id_category: food.id_category,
                            name:food.name,
                            description:food.descritpion,
                            price:food.price,
                            is_active:active,
                            is_emphased:emphased,
                            sortList:counting2
                            }	
                            total2.push(new1)
                            if(patch2){
                            put_food(new1).then(res => {
                                console.log("mod :"+JSON.stringify(res));
                            });
                            
                            }
                        }else if(!patch2){
                        patch2 = true;
                        }
                        else{
                            total2.push(food);
                        }
                
                   
            
            });
            total2.sort((a, b) => a.sortList - b.sortList);
            console.log("total 2 "+JSON.stringify(total2));
            this.props.changeFoods(total2);
                
            this.props.popupParentCallback({display:"inline-flex"}, "Le plat à été supprimé avec succès", "success");
			delete_food(this.props.id).then(res => {
                var big = [];
              
            this.props.count.forEach((counter,index) => {			
                var keys = Object.keys(counter);		
                if(this.props.id === parseInt(keys[0])){
                    var key = this.props.category_id;
					var puzzle  = {}
                    console.log("key value "+parseInt(counter[key]));
					puzzle[key] = parseInt(counter[key])-1;
                    big.push(puzzle);
                    //big = [];
                }
                else{
                    big.push(counter);
                }
              
              });
                this.props.changeCount(big);
                var total = [];
                this.props.foods.forEach((food,index) => {
                        
                    if(food["id"] !== this.props.id){
                      total.push(food);
                    }


                  
                  });
                  this.props.allergens.forEach((allergen,index) => {
							
                    if(allergen["id_food"] === this.props.id){
                        delete_allergen(allergen["id"]).then(res => {
                        });
                    }
                  
                  });

                  this.props.images.forEach((image,index) => {
                    
                    if(image["id_food"] === this.props.id){
                        delete_image(image["id"]).then(res => {
                        });
                    }
                  
                  });
                  this.props.changeFoods(total);
                  
              
              });
			}
        
    }

    componentDidUpdate(prevProps) {
        if (this.props.food_name != prevProps.food_name || this.props.description != prevProps.description || this.props.price != prevProps.price || this.props.is_active != prevProps.is_active || this.props.is_emphased != prevProps.is_emphased || this.props.selectSort != prevProps.selectSort) {
          this.setState({ food_name: this.props.food_name, description: this.props.description, price: this.props.price });
        }

        if (this.props.foods !== prevProps.foods) {
           
            this.props.foods.forEach((food,index) => {
                console.log("on rentre "+food.name+" "+this.props.food_name);
                if(food.name.localeCompare(this.props.food_name)===0){
                    
                    if(parseInt(this.state.selectSort) !== food.sortList){
                       
                        this.setState({selectSort:food.sortList});
                    }
                   
                }
            });
          }

        
      }

    
    onFileChange = event => { 
        // Update the state     
        this.setState({ selectedFile: event.target.files[0] });
    }; 

    renderSort(){
        return this.props.foods.map((food,index) => {  
            if(food["id_category"] === this.props.category_id){
                console.log("renderSort "+food.sortList);
                return (
                    <option key={index} value={food.sortList}>{food.sortList}</option>
            ) 
            }
            
        });  
        }

    render() {
        if(typeof(this.props.images[0])!=="undefined"){
            var display = "";
            this.props.images.forEach((image, index) => (
                image.id_food == this.props.id?display=image.name:null
            ));
                return (
                    <form className="food-card" onSubmit={this.onSubmitFood}>
                        <div className="header">
                            <input type="text" name="id" value="ID" class="invisible"/>
                            <input type="text" name="food_name" value={this.state.food_name}  onChange={this.onChange} className="title" placeholder="Nom du plat"/>
                            <input type="number" step="0.01" name="price" value={this.state.price}  onChange={this.onChange} className="price" placeholder="Prix"/>
                        </div>
        
                        <img className="illustration" src={process.env.REACT_APP_API+'/api/display/'+display} alt=""/>
                        <input name="illustration" type="file" onChange={this.onFileChange} />
        
                        <div className="footer">
                            <textarea name="description" value={this.state.description}  onChange={this.onChange} className="description" placeholder="Description"/>
                            <div className="allergenWrapper">
                                <p>Allergène</p>
                                <div className="custom-select-wrapper allergen">
                                    <select name="allergen1" value={this.state.allergen1}  onChange={this.onChange}>
                                        <option value="Aucun">Aucun</option>
                                        <option value="Gluten">Gluten</option>
                                        <option value="Fruits à coque">Fruits à coque</option>
                                        <option value="Oeuf">Oeuf</option>
                                        <option value="Poisson">Poisson</option>
                                        <option value="Soja">Soja</option>
                                        <option value="Lait">Lait</option>
                                        <option value="Crustacé">Crustacé</option>
                                        <option value="Mollusque">Mollusque</option>
                                        <option value="Céléri">Céléri</option>
                                        <option value="Moutarde">Moutarde</option>
                                        <option value="Sésame">Sésame</option>
                                        <option value="Lupin">Lupin</option>
                                        <option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
                                        <option value="Arachide">Arachide</option>
                                    </select>
                                    <select name="allergen2" value={this.state.allergen2}  onChange={this.onChange}>
                                        <option value="Aucun">Aucun</option>
                                        <option value="Gluten">Gluten</option>
                                        <option value="Fruits à coque">Fruits à coque</option>
                                        <option value="Oeuf">Oeuf</option>
                                        <option value="Poisson">Poisson</option>
                                        <option value="Soja">Soja</option>
                                        <option value="Lait">Lait</option>
                                        <option value="Crustacé">Crustacé</option>
                                        <option value="Mollusque">Mollusque</option>
                                        <option value="Céléri">Céléri</option>
                                        <option value="Moutarde">Moutarde</option>
                                        <option value="Sésame">Sésame</option>
                                        <option value="Lupin">Lupin</option>
                                        <option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
                                        <option value="Arachide">Arachide</option>
                                    </select>
                                    <select name="allergen3" value={this.state.allergen3}  onChange={this.onChange}>
                                        <option value="Aucun">Aucun</option>
                                        <option value="Gluten">Gluten</option>
                                        <option value="Fruits à coque">Fruits à coque</option>
                                        <option value="Oeuf">Oeuf</option>
                                        <option value="Poisson">Poisson</option>
                                        <option value="Soja">Soja</option>
                                        <option value="Lait">Lait</option>
                                        <option value="Crustacé">Crustacé</option>
                                        <option value="Mollusque">Mollusque</option>
                                        <option value="Céléri">Céléri</option>
                                        <option value="Moutarde">Moutarde</option>
                                        <option value="Sésame">Sésame</option>
                                        <option value="Lupin">Lupin</option>
                                        <option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
                                        <option value="Arachide">Arachide</option>
                                    </select>
                                    <select name="allergen4" value={this.state.allergen4}  onChange={this.onChange}>
                                        <option value="Aucun">Aucun</option>
                                        <option value="Gluten">Gluten</option>
                                        <option value="Fruits à coque">Fruits à coque</option>
                                        <option value="Oeuf">Oeuf</option>
                                        <option value="Poisson">Poisson</option>
                                        <option value="Soja">Soja</option>
                                        <option value="Lait">Lait</option>
                                        <option value="Crustacé">Crustacé</option>
                                        <option value="Mollusque">Mollusque</option>
                                        <option value="Céléri">Céléri</option>
                                        <option value="Moutarde">Moutarde</option>
                                        <option value="Sésame">Sésame</option>
                                        <option value="Lupin">Lupin</option>
                                        <option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
                                        <option value="Arachide">Arachide</option>
                                    </select>
                                    <select name="allergen5" value={this.state.allergen5}  onChange={this.onChange}>
                                        <option value="Aucun">Aucun</option>
                                        <option value="Gluten">Gluten</option>
                                        <option value="Fruits à coque">Fruits à coque</option>
                                        <option value="Oeuf">Oeuf</option>
                                        <option value="Poisson">Poisson</option>
                                        <option value="Soja">Soja</option>
                                        <option value="Lait">Lait</option>
                                        <option value="Crustacé">Crustacé</option>
                                        <option value="Mollusque">Mollusque</option>
                                        <option value="Céléri">Céléri</option>
                                        <option value="Moutarde">Moutarde</option>
                                        <option value="Sésame">Sésame</option>
                                        <option value="Lupin">Lupin</option>
                                        <option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
                                        <option value="Arachide">Arachide</option>
                                    </select>
                                    <select name="allergen6" value={this.state.allergen6}  onChange={this.onChange}>
                                        <option value="Aucun">Aucun</option>
                                        <option value="Gluten">Gluten</option>
                                        <option value="Fruits à coque">Fruits à coque</option>
                                        <option value="Oeuf">Oeuf</option>
                                        <option value="Poisson">Poisson</option>
                                        <option value="Soja">Soja</option>
                                        <option value="Lait">Lait</option>
                                        <option value="Crustacé">Crustacé</option>
                                        <option value="Mollusque">Mollusque</option>
                                        <option value="Céléri">Céléri</option>
                                        <option value="Moutarde">Moutarde</option>
                                        <option value="Sésame">Sésame</option>
                                        <option value="Lupin">Lupin</option>
                                        <option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
                                        <option value="Arachide">Arachide</option>
                                    </select>
                                    <select name="allergen7" value={this.state.allergen7}  onChange={this.onChange}>
                                        <option value="Aucun">Aucun</option>
                                        <option value="Gluten">Gluten</option>
                                        <option value="Fruits à coque">Fruits à coque</option>
                                        <option value="Oeuf">Oeuf</option>
                                        <option value="Poisson">Poisson</option>
                                        <option value="Soja">Soja</option>
                                        <option value="Lait">Lait</option>
                                        <option value="Crustacé">Crustacé</option>
                                        <option value="Mollusque">Mollusque</option>
                                        <option value="Céléri">Céléri</option>
                                        <option value="Moutarde">Moutarde</option>
                                        <option value="Sésame">Sésame</option>
                                        <option value="Lupin">Lupin</option>
                                        <option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
                                        <option value="Arachide">Arachide</option>
                                    </select>
                                    <select name="allergen8" value={this.state.allergen8}  onChange={this.onChange}>
                                        <option value="Aucun">Aucun</option>
                                        <option value="Gluten">Gluten</option>
                                        <option value="Fruits à coque">Fruits à coque</option>
                                        <option value="Oeuf">Oeuf</option>
                                        <option value="Poisson">Poisson</option>
                                        <option value="Soja">Soja</option>
                                        <option value="Lait">Lait</option>
                                        <option value="Crustacé">Crustacé</option>
                                        <option value="Mollusque">Mollusque</option>
                                        <option value="Céléri">Céléri</option>
                                        <option value="Moutarde">Moutarde</option>
                                        <option value="Sésame">Sésame</option>
                                        <option value="Lupin">Lupin</option>
                                        <option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
                                        <option value="Arachide">Arachide</option>
                                    </select>
                                </div>
                            </div>
                            <div class="stockWrapper">
                                <p>En stock</p>
                                <div className="custom-select-wrapper stock">
                                    <select name="stock" value={this.state.stock}  onChange={this.onChange}>
                                        <option value="non">Non</option>
                                        <option value="oui">Oui</option>
                                    </select>
                                </div>
                            </div>
                            <div class="dayfoodWrapper">
                                <p>Plat du jour</p>
                            </div>
                            <div className="custom-select-wrapper dayfood">
                                <select name="dayfood" value={this.state.dayfood}  onChange={this.onChange}>
                                    <option value="non">Non</option>
                                    <option value="oui">Oui</option>
                                </select>
                            </div>
                            <div class="stockWrapper">
                                <p>Ordre</p>
                                <div className="custom-select-wrapper stock">
                                <select name="selectSort" value={this.state.selectSort}  onChange={this.onChange}>
                                            {this.renderSort()}
                                </select>
                                </div>
                            </div>
                        </div>
                        <div class="actions">
                            <label class="command delete" onClick={(event) => this.handleDelete(event)}>
                                <input type="submit"  name="delete" value="Supprimer" class="invisible"/>
                                <div>X</div>
                            </label>
                            <label class="command edit" onClick={(event) => this.handleModify(event)} >
                                <input type="submit"  name="modify" value="Modifier" class="invisible"/>
                                <div>&#10003;</div>
                            </label>
                        </div>									
                        <p id="food-response">{this.state.food_text}</p>
                    </form>	
                );
            
        }
        return null;
        
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FoodWrapperAdmin);



// WEBPACK FOOTER //
// ./src/components/FoodWrapperAdmin.js